import toast from 'jquery-toast-plugin';

/*
 * continuous click
 */
jQuery(function ($) {
	// form二度押し防止
	var iClickCount = 0;
	$(document).on('submit', 'form:not(.available-continuous-click)', function () {
		if (iClickCount == 0) {
			iClickCount = 1;
		} else {
			alert('ただいま処理中です。OKを押してそのままお待ちください。');
			return false;
		}
	});
});

/*
 * テキストエリアを自動リサイズ
 */
jQuery(function ($) {
	if ($('.autosize').length > 0 && $('.autosize.js-message-textarea-1000').length == 0  ) {
		autosize($('.autosize'));
	}
});


/*
 * 都道府県と市区町村の連動
 */
// 市区町村選択テキスト（郵便番号からの読み込み）
var sSelectCity = '';

jQuery(function ($) {
	if ($('.link-city.state-id').length > 0) {
		$(".link-city.state-id").on("change", function () {
			if ($(this).val() == '') {
				$('.city-id option').remove();
				$('.city-id.have-empty').append('<option value="">指定しない</option>');
				return;
			}
			$.ajax({
				url: '/ajax/get-cities/' + $(this).val(),
				type: 'GET',
				datatype: 'json',
				timeout: 30000
			}).done(function (oData) {
				if (oData['iCode'] == 200) {
					$('.city-id option').remove();
					$('.city-id.have-empty').append('<option value="">指定しない</option>');
					$.each(oData['aCities'], function (i, sValue) {
						var sOption = '<option value="' + i + '">' + sValue + '</option>';
						$('.city-id').append(sOption);
					});
					if (sSelectCity != '') {
						$('.city-id option').filter(function (index) {
							return $(this).text() === sSelectCity;
						}).prop('selected', true);
						sSelectCity = '';
					}
				} else {
					$.toast({
						heading: 'エラーが発生しました',
						text: oData['sMessage'],
						showHideTransition: 'slide',
						icon: 'error',
						position: 'bottom-right',
						hideAfter: false
					});
				}
			}).fail(function (oData, sTextStatus, sErrorThrown) {
				$.toast({
					heading: 'データの読み込みに失敗しました',
					text: 'お手数ですが、再度都道府県を選び直してください。',
					showHideTransition: 'slide',
					icon: 'error',
					position: 'bottom-right',
					hideAfter: 6000
				});
			}).always(function (oData) {
			});
		});
	}
});

/*
 * 郵便番号から住所読み込み
 */
jQuery(function ($) {
	if ($('.zip-code.selectbox-city').length > 0) {
		$(document).on(oEventNames.end, '.load-address', function (event) {
			if (!bIsScrolling) {
				event.preventDefault();
				// jpostalは、市区町村selectboxに対応していないため、別APIを利用
				var sUrl = 'https://api.zipaddress.net?callback=?';
				var oQuery = { 'zipcode': $('.zip-code.selectbox-city').val() };
				$.getJSON(sUrl, oQuery, function (oResponse) {
					// 都道府県選択
					$('.link-city.state-id option').filter(function (index) {
						return $(this).text() === oResponse.pref;
					}).prop('selected', true);
					// 市区町村読み込み＋市区選択
					sSelectCity = oResponse.city;
					$(".link-city.state-id").trigger("change");
					// 町村入力
					$('.input-address').val(oResponse.town);
				});
			}
		});
	} else if ($('.zip-code').length > 0) {
		$('.zip-code').jpostal({
			click: '.load-address',
			postcode: [
				'.zip-code'
			],
			address: {
				'.state-id': '%3',
				'.input-address': '%4%5'
			}
		});
	}
});

/*
 * ファイル選択（boostrap）
 */
jQuery(function ($) {
	// ファイル名を表記
	$(".custom-file-input").on("change", function () {
		var sFileName = $(this).val().split("\\").pop();
		$(this).siblings(".custom-file-label").addClass("selected").html(sFileName);
	});
	// ファイルの取消
	$('.custom-file-input-reset').click(function () {
		var iNumber = $(this).data('number');
		$('.input-number' + iNumber).next('.custom-file-label').html('ファイル選択...');
		$('.input-number' + iNumber).val('');
	})
});

/*
 * チェックボックス選択数制限
 */
jQuery(function ($) {
	if ($('.checkbox-limit-count').length > 0) {
		setCheckBoxDisabled();
		$(".checkbox-limit-count input[type=checkbox]").click(function () {
			setCheckBoxDisabled();
		});
		function setCheckBoxDisabled() {
			$('.checkbox-limit-count').each(function (i, elem) {
				var iAvailableCheckCount = $(elem).data('limit-count');
				var iCount = $(elem).find('input[type=checkbox]:checked').length;
				var $oNotCheckedInput = $(elem).find('input[type=checkbox]').not(':checked');
				if (iCount >= iAvailableCheckCount) {
					$oNotCheckedInput.attr("disabled", true);
				} else {
					$oNotCheckedInput.attr("disabled", false);
				}
			});
		}
	}
});

$(function () {
	// ▼※を必須マークに変換
	if ($('.mypage, .login-signup').length > 0) {
		$('label').each(function () {
			let dataname = $(this).html();
			let brank = "※";
			let regExp = new RegExp(brank, "g");
			let name = dataname.replace(regExp, '<span class="required">必須</span>');
			$(this).html(name);
		});
	};
	if ($('.mypage-list-item').length) {
		$('.mypage-list-item').each(function () {
			let link = $(this).children('a').attr('href');
			let url = location.href;
			if (link == url) {
				$(this).children('a').addClass('active');
			}
		});
	};
});
